export default {
      id: "menu__analytics_fill-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "img/icons.svg#menu__analytics_fill",
      toString: function () {
        return this.url;
      }
    }